import { Injectable } from '@angular/core';
import { ChatMessage, Room } from '../model/chat.message';
import { VariableService } from './variable.service';
import { ApiService } from './api.service';
import { MAKE_ARRAY_UNIQUE, RES_OK } from 'src/app/constants/constants';
import { ChatErrorService } from './chat-error.service';
import { ChatDataGroupingService } from './chat-data-grouping.service';
import * as _ from 'lodash';
import { AgentsService } from './agents.service';
import { ChatComponent } from '../../components/apps/chat/chat/chat.component';
import { FormControl } from '@angular/forms';
import { debounceTime } from 'rxjs';
import { ChatRoomMembersData } from '../model/user-interfaces';

@Injectable({
  providedIn: 'root'
})
export class ChatApiCallService {
  totalLiveChatPages: number = 0;
  totalUnassignedPages: number = 0;
  totalMentionPages: number = 0;
  currentLiveChatPages: number = 0;
  currentUnassignedPages: number = 0;
  currentMentionPages: number = 0;

  constructor(
    private vars: VariableService,
    private apiService: ApiService,
    private errorService: ChatErrorService,
    private cdg: ChatDataGroupingService,
    private agentsService: AgentsService
  ) { }

  getMessageByTmid(tmid: string, roomId: number): Promise<ChatMessage> {
    return new Promise((resolve, reject) => {
      this.apiService.getMessageByTmid(tmid, roomId ? roomId : this.vars.roomId).subscribe((res: any) => {
        console.log('getMessageByTmid res', res);
        resolve(res?.data);
      },
        (err) => {
          console.log('getMessageByTmid err', err);
          resolve(null as any);
        }
      );
    });
  }


  loadMoreChatMessages() {
    if (this.pagination?.current_page < this.pagination?.total_page
      && this.pagination?.total_item && !this.vars.messagesLoading && !this.vars.loadMoreMessages) {
      this.vars.loadMoreMessages = true;
      this.vars.pagination.current_page += 1;
      this.getChatMessages(this.vars.selectedChat);
    }
  }

  get pagination() {
    return this.vars.pagination;
  }

  get paginationChatHistory() {
    return this.vars.paginationChatHistory;
  }

  getUserChatHistory(userId: number, roomId: number) {
    let data = {
      page: this.paginationChatHistory?.current_page || 1,
      limit: this.paginationChatHistory?.per_page || 100
    }
    this.vars.chatHistoryMessagesLoading = true;
    return this.apiService.getUserChatHistory(userId, roomId, data).subscribe(res => {
      console.log('getUserChatHistory res', res);
      if (RES_OK(res) && res) {
        this.vars.paginationChatHistory = res?.pagination;
        if (!res.messages?.length) {
          res.messages = [];
        }
        this.vars.chatMessages = MAKE_ARRAY_UNIQUE([...this.vars.chatMessages, ...res?.messages], 'messageId');
      }
      else {
        this.errorService.showSnackbarToast("An error occurred to fetch user old chats", 'error');
      }
      this.vars.chatHistoryMessagesLoading = false;
    },
      (err) => {
        this.vars.chatHistoryMessagesLoading = false;
        console.log('getUserChatHistory err', err);
        this.errorService.showSnackbarToast("An error occurred to fetch user old chats", 'error');
      });
  }


  async getChatMessages(room: Room): Promise<number> {
    return new Promise((resolve, reject) => {
      this.vars.userDetails = null;
      this.getUserDetails(room?.initiatorId);
      const page = this.pagination?.current_page || 1;
      let data = {
        page: page,
        limit: this.pagination?.per_page || 100
      }
      this.apiService.getChatMessages(data, room?.roomId, room.initiatorId).subscribe((res) => {
        // console.log('getChatMessages res', res);
        if (RES_OK(res)) {
          for (let index = 0; index < res?.data?.messages?.length; index++) {
            const element = res?.data?.messages[index];
            element.options = this.cdg.parseOptions(element.options);
          }

          if (!res?.data?.messages?.length) {
            res.data.messages = []
          }
          this.vars.chatMessages = MAKE_ARRAY_UNIQUE([...this.vars.chatMessages, ...res?.data?.messages], 'messageId');
          if (page == 1) {
            room.totalOldMessagesPagination = res?.data?.totalOldMessagesPagination;
            if (room.roomId == this.vars?.selectedChat?.roomId) {
              this.vars.selectedChat.totalOldMessagesPagination = res?.data?.totalOldMessagesPagination;
            }
          }
          this.vars.pagination = res.data.pagination;
          resolve(0);
        }
        else {
          this.errorService.showSnackbarToast('An error occurred to fecth chat messages')
        }
        if (this.vars?.openTab == 'live') {
          let index = this.vars?.liveRooms?.findIndex(user => user?.roomId == room?.roomId);
          if (index > -1) {
            this.vars.liveRooms[index].unReadCount = 0;
          }
        } else {
          let index = this.vars?.mentionedRooms?.findIndex(user => user?.roomId == room?.roomId);
          if (index > -1) {
            this.vars.mentionedRooms[index].unReadCount = 0;
          }
        }
        this.vars.messagesLoading = false;
        this.vars.loadMoreMessages = false;
        console.log('chatMessages', this.vars.chatMessages);
        resolve(1);
      }, (err) => {
        this.vars.messagesLoading = false;
        this.vars.loadMoreMessages = false;
        this.errorService.showSnackbarToast('An error occurred to fecth chat messages')
        console.log('getChatMessages res', err);
        resolve(-1);
      })
    }
    );
  }

  getMembers(roomId: number): Promise<ChatRoomMembersData> {
    return new Promise((resolve, reject) => {
      let data = {
        page: 1,
        limit: 100
      }
      this.apiService.getRoomMembers(data, roomId).subscribe((res) => {
        // console.log('getMembers res', res);
        this.vars.members = res?.data?.members || [];
        if (RES_OK(res)) {
          resolve(res?.data);
        }
        else {
          resolve(null)
        }
      },
        (err) => {
          // console.log('getMembers err', err);
          resolve(null)
        }
      );
    })
  }

  //vertical scroll to bottom or top
  scrollTo(scrollTopCase = false, elementId = ''): void {
    try {
      let ele = document.getElementById('messages-lis-container');
      if (scrollTopCase) {

      }
      if (elementId) {
        ele = document.getElementById(elementId);
      }
      if (ele) {
        // if (ele?.classList?.contains('smooth-scroll-chats') && !scrollTopCase) {
        //   ele.classList.remove('smooth-scroll-chats');
        // }
        ele.scrollTo({
          behavior: 'smooth',
          top: scrollTopCase ? -ele.scrollHeight : ele.scrollHeight,
        });
      }
    } catch (err) {
      console.error('Scroll to bottom failed', err);
    }
  }

  getAllUnassignedChats(userPage = 1) {
    let params = {
      page: userPage,
      limit: 60
    }
    this.apiService.getAllUnassignedChats(params).subscribe((res) => {
      if (!res?.chats?.length) {
        res.chats = [];
      }
      this.vars.unAssignedRooms.push(...res?.chats as any);
      this.vars.unAssignedRooms = _.uniqBy(this.vars?.unAssignedRooms, (user) => user?.roomId);
      this.totalUnassignedPages = res?.totalPages;
      this.currentUnassignedPages = res?.page;
      if (this.vars?.openTab == 'unassigned') {
        this.vars.users = [...this.vars?.unAssignedRooms];
      }
      this.vars.usersLoading = false;
      console.log('getAllAssignedChats', res);
    }, (err) => {
      this.vars.usersLoading = false;
      console.log('getAllAssignedChats err', err);
    })
  }

  getLiveChatsOfAllAgents(page = 1, search = '', filter = '') {
    let params = {
      page: page,
      limit: 50,
      search: search,
      status: filter
    }
    this.apiService.getLiveChatsOfAllAgents(params).subscribe((res) => {
      if (!res?.chats?.length) {
        res.chats = [];
      }
      this.vars?.liveRooms.push(...res?.chats as any);
      this.totalLiveChatPages = res?.totalPages;
      this.vars.liveRooms = _.uniqBy(this.vars?.liveRooms, (user) => user?.roomId);
      this.vars.users = [...this.vars?.liveRooms];
      this.vars.usersLoading = false;
      console.log('getLiveChatsOfAllAgents', res);
    }, (err) => {
      this.vars.usersLoading = false;
      console.log('getLiveChatsOfAllAgents err', err);
    })
  }

  getAllLiveChats(userPage = 1) {
    let params = {
      page: userPage,
      limit: 60
    }
    this.apiService.getAllLiveChats(params).subscribe((res) => {
      this.vars.liveRooms.push(...res?.chats as any);
      this.vars.liveRooms = _.uniqBy(this.vars?.liveRooms, (user) => user?.roomId);
      this.totalLiveChatPages = res?.totalPages;
      this.currentLiveChatPages = res?.page;
      if (this.vars?.openTab == 'live') {
        this.vars.users = [...this.vars?.liveRooms];
      }
      // setTimeout(() => {
      //   this.vars.liveRooms[0].typing = true;
      //   this.vars.liveRooms[1].typing = true;
      // }, 2500);
      this.vars.usersLoading = false;
      console.log('getAllLiveChats', res);
    }, (err) => {
      this.vars.usersLoading = false;
      console.log('getAllLiveChats err', err);
    })
  }

  getAllMentionedChats(userPage = 1) {
    let params = {
      page: userPage,
      limit: 60
    }
    this.apiService.getAllMentionedChats(params).subscribe((res) => {
      this.vars.mentionedRooms.push(...res?.chats as any);
      this.vars.mentionedRooms = _.uniqBy(this.vars?.mentionedRooms, (user) => user?.roomId);
      if (this.vars?.openTab == 'mentions') {
        this.vars.users = [...this.vars?.mentionedRooms];
      }
      this.totalMentionPages = res?.totalPages;
      this.currentMentionPages = res?.page;
      this.vars.usersLoading = false;
      console.log('getAllMentionedChats', res);
    }, (err) => {
      this.vars.usersLoading = false;
      console.log('getAllMentionedChats err', err);
    })
  }

  getAgentsStats() {
    this.agentsService.getAgentsStats().subscribe((res) => {
      if (res?.statusCode == 200) {
        this.vars.totalAgents = res?.data?.total_agents;
        this.vars.onlineAgents = res?.data?.online;
        this.vars.busyAgents = res?.data?.busy;
        this.vars.offlineAgents = res?.data?.offline;
      }
      console.log('Agent stats', res);
    }, (err) => {
      console.log('error fetching agent status', err);
    })
  }

  getAgentChatHistory(id: number, page = 1, search = '', type = 'today') {
    let params = {
      page: page,
      limit: 60,
      search: search,
      date: type
    }
    this.apiService.getAgentChatHistory(params, id).subscribe((res: any) => {
      this.vars.liveRooms.push(...res?.chats as any);
      this.vars.liveRooms = _.uniqBy(this.vars?.liveRooms, (user) => user?.roomId);
      this.vars.users = [...this.vars?.liveRooms];
      this.totalLiveChatPages = res?.totalPages;
      this.vars.usersLoading = false;
      console.log('getAgentChatHistory', res);
    }, (err) => {
      this.vars.usersLoading = false;
      console.log('getAgentChatHistory err', err);
    })
  }

  closeRoom(roomId: number){
    this.vars.closeRoomLoader =true;
    this.apiService.closeRoom(roomId).subscribe((res: any) => {
      console.log('closeRoom', res);
      this.vars.closeRoomLoader =false;
    },(err) => {
      this.vars.closeRoomLoader =false;
      console.log('error in close room', err);
    })
  }

  getUserDetails(userId: number) {
    this.apiService.getUserDetails(userId).subscribe((res: any) => {
      this.vars.userDetails = res;
      console.log('getUserDetail', res);
    }, (err) => {
      console.log('error in getUserDetail', err);
    })
  }
}
